export default __webpack_public_path__ + "2025_Baseball_Card.c41ef5de.pdf";